/*
  ['Publication settings', '/publications', pubScope('publication_settings.list'), false],
  Returns an object with link data, formatted for the Nav component
*/
import { get } from '../../../utils/shared/api';
import LinkPermissionManager from './link_permission_manager';
import '../../../utils/integration/PlatformLinkBuilder';
import PlatformLinkBuilder from '../../../utils/integration/PlatformLinkBuilder';

const secondaryLinksArray = (linkManager:LinkPermissionManager, cashoutBalance:string) => {
  const links = [
    {
      ...linkManager.build('Messages'),
      icon: 'messages',
      noticeRequest: () =>
        get(PlatformLinkBuilder.build('messages/unread_message_count'), false).then(
          response => !!response.unread_message_count
        )
    }
  ];

  cashoutBalance !== '$0' && links.unshift({ name: cashoutBalance, path: '/account/activity' } as never);

  return links;
};

export default (linkManager:LinkPermissionManager, onIaVersionChange:any, cashoutBalance:any) => ({
  primaryLinks: [
    linkManager.build('Tasks'),
    linkManager.build('Calendar'),
    linkManager.build('Campaigns'),
    linkManager.build('Drafts'),
    linkManager.build('Ideation'),
    linkManager.build('Stories'),
    linkManager.build('Media'),
    linkManager.build('Analytics'),
    linkManager.build('Talent'),
    linkManager.build('Portfolio')
  ],
  createLinks: [
    [
      linkManager.build('Story'),
      linkManager.build('Recurring story'),
      linkManager.build('Upload story')
    ],
    [linkManager.build('Pitch'), linkManager.build('Pitch request')],
    [linkManager.build('Event')],
    [linkManager.build('User')],
    [linkManager.build('Campaign')],
    [linkManager.build('Talent request')],
    [linkManager.build('Draft')]
  ],
  secondaryLinks: secondaryLinksArray(linkManager, cashoutBalance),
  userLinks: [
    linkManager.build('Your account'),
    linkManager.build('Command center'),
    {
      name: 'Help center',
      path: 'https://support.contently.com/'
    },
    linkManager.build('Financial activity'),
    [linkManager.build('Publication settings')],
    // 'Switch to Nav V2' removed (Lisa Farino, Row 49 #37). Toggle has
    // been inert since 2022-08-01 (commit 74e0681c7b set V1 as the
    // hardcoded universal default; IaProvider rewrites the cookie to
    // 'V1' on every page load via withCookieJar, so clicking 'Switch to
    // Nav V2' has no observable effect). Keeping the link in the menu
    // misled users — Lisa flagged it as broken. Removing entirely
    // matches the de facto behaviour for the last ~4 years.
    [linkManager.build('Sign out')]
  ]
});
